/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from 'reactstrap';
import { Pressable } from 'react-native';
import { connect } from 'react-redux';
import Image from 'Components/Image';

import {
    StyleImageContainer,
    ProductImg,
    Variation,
    RowFlexCenter,
    MobileListStyle,
    MobileListStyleBold,
    Remarks,
} from 'Containers/User/Styles/ComponentStyles';

import { cartProductDetailsTable, ProductListItemStyle, trashButton, trashIcon } from 'Containers/Cart/Styles/CartStyles';
import { Trash, Close } from 'Icons/Icons';

import Actions from 'Redux/Actions';
import Selectors from 'Redux/Selectors';
import Utils from 'Lib/Utils';
import NavActions from 'Services/Navigation/Actions';
import VariantSelector from 'Containers/Products/Components/VariantSelector';
import ErrorMessage from 'Components/Common/ErrorMessage';
import EditableQuantity from './EditableQuantity';

function EditableProductsListComponent(props) {
    const { product, goldPrice, stockCheckLoading, key, updateCartQuantityError } = props;

    const { id, name, selectedVariant, quantity, imageUrl, imageFileNames, remarks, customAttributes, availableStock = 0 } = product;

    const [selectVariant, setSelectVariant] = useState(selectedVariant);
    const [quantityError, setQuantityError] = useState(undefined);

    const variantPrice = Utils.Jemisys.getItemVariantPrice(product, selectVariant, goldPrice);

    const totalPrice = variantPrice * quantity;

    const image = imageFileNames?.length ? imageFileNames[0] : imageUrl[0];

    const onChangeVariation = (newVariant) => {
        const { updateAddToCart, updateRemoveFromCart } = props;
        updateRemoveFromCart({ product });
        updateAddToCart({ product, selectedVariant: newVariant, quantity, remarks });
    };

    const onQuantityChanged = (newQuantity) => {
        setQuantityError(undefined);
        const { updateQuantity } = props;
        updateQuantity({ product, newQuantity });
        if (newQuantity > quantity) {
            setQuantityError(updateCartQuantityError);
        }
    };

    const onRemoveItem = () => {
        const { removeFromCart } = props;
        removeFromCart({ product });
    };

    const renderRemarks = () => {
        if (!remarks) return null;
        return <div css={Remarks}>{`Remarks: ${remarks}`}</div>;
    };

    const renderVariation = () => {
        const salesType = Utils.Product.getSalesType(customAttributes);
        const variantName = Utils.Product.getItemVariantSizeLengthString(selectVariant);

        if (salesType === 'JEWELERY') return false;
        return <div css={Variation}>{variantName}</div>;
    };

    const renderMobileView = () => {
        return (
            <div className='d-md-none'>
                <Row className='mt-5 mb-5 d-flex' style={{ alignItems: 'center' }}>
                    <Col xs='5'>
                        <Image
                            css={ProductImg}
                            url={image}
                            alt='Product Img'
                        />
                    </Col>
                    <Col xs='5'>
                        <div
                            css={ProductListItemStyle}
                            style={{ fontWeight: '700' }}
                        >
                            {name}
                        </div>
                        {renderVariation()}
                        <div css={MobileListStyle}>
                            <span css={MobileListStyleBold}>Quantity: </span>
                            {quantity}
                        </div>
                        <div css={MobileListStyle}>
                            <span css={MobileListStyleBold}>Price: </span>
                            {Utils.Formatter.currencyFormatter(variantPrice)}
                        </div>
                        <div css={MobileListStyle}>
                            <span css={MobileListStyleBold}>Total: </span>
                            {Utils.Formatter.currencyFormatter(totalPrice)}
                        </div>

                        <Col xs='2' style={{ marginTop: 10 }}>
                            <EditableQuantity quantity={quantity} onQuantityChanged={onQuantityChanged} />
                        </Col>
                    </Col>
                    <Col xs='2'>
                        <Pressable disabled={stockCheckLoading} style={{ padding: 5 }}>
                            <Trash css={trashButton} onClick={onRemoveItem} />
                        </Pressable>
                    </Col>
                </Row>
            </div>
        );
    };

    const renderWebView = () => {
        return (
            <Row css={cartProductDetailsTable} className='py-5 d-none d-md-flex' style={{ alignItems: 'center', justifyContent: 'space-between' }}>
                <Col xs={10} xl={10}>
                    <Row>
                        <Pressable
                            onPress={() => NavActions.navToProductDetails(id)}
                        >
                            <Col
                                xs='4'
                                className='p-0'
                                style={{
                                    display: 'flex',
                                    // justifyContent: 'center',
                                    // alignItems: 'center',
                                }}
                            >
                                <Image
                                    css={ProductImg}
                                    url={image}
                                    alt='Product Img'
                                />
                            </Col>
                            <ErrorMessage
                                error={quantityError}
                                style={{ marginTop: 30, marginBottom: -10 }}
                                textStyle={{ textAlign: 'left' }}
                            />
                        </Pressable>

                        <Col xs='6'>
                            <Pressable
                                style={{ flex: 1 }}
                                onPress={() => NavActions.navToProductDetails(id)}
                            >
                                <div
                                    css={ProductListItemStyle}
                                    style={{ fontWeight: '600', fontSize: 15 }}
                                >
                                    {name}
                                </div>
                                <div css={ProductListItemStyle}>
                                    RM
                                    {' '}
                                    {totalPrice.toFixed(2)}
                                </div>
                            </Pressable>
                            {(availableStock > 0 && quantity > 0) ? (
                                <VariantSelector
                                    product={product}
                                    selectedVariant={selectVariant}
                                    onVariantSelected={onChangeVariation}
                                />
                            )
                                : <p style={{ color: 'red', fontSize: 14, fontWeight: 500 }}>Sold out</p>}

                            {(availableStock < 1 && quantity < 1)
                            && (
                                <p style={{ color: 'red', fontSize: 14, fontWeight: 500 }}>
                                    Sold out
                                </p>
                            )}

                            {renderRemarks()}
                        </Col>

                        <Col xs='2' css={RowFlexCenter}>
                            <EditableQuantity quantity={quantity} onQuantityChanged={onQuantityChanged} product={product} />
                        </Col>
                    </Row>
                </Col>
                <Col xs={1}>
                    <Button disabled={stockCheckLoading} css={trashButton} onClick={onRemoveItem}>
                        <Close css={trashIcon} />
                    </Button>
                </Col>
            </Row>
        );
    };

    return (
        <>
            {renderWebView()}
            {renderMobileView()}
        </>
    );
}

const mapStateToProps = (state) => ({
    goldPrice: Selectors.getHomeGoldPrice(state),
    stockCheckLoading: Selectors.getUiStockCheckAttempting(state),
    updateCartQuantityError: Selectors.getCartUpdateQuantityError(state),
});

const mapDispatchToProps = (dispatch) => ({
    updateAddToCart: (item) => dispatch(Actions.cartUpdateAddToCart(item)),
    updateRemoveFromCart: (params) => dispatch(Actions.cartUpdateRemoveFromCart(params)),
    updateQuantity: (params) => dispatch(Actions.cartUpdateCartQuantity(params)),
    removeFromCart: (params) => dispatch(Actions.cartRemoveFromCart(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditableProductsListComponent);
